import React from "react";
import {Dropdown, Typography} from "antd";
import {MenuOutlined, MoreOutlined} from "@ant-design/icons";
import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";

import "./PageThumb.css";

const {Text} = Typography;

const PAGE_MENU_ITEMS = [
	{key: "move", label: "Sposta in posizione…"},
	{type: "divider"},
	{key: "delete", label: "Elimina pagina", danger: true}
];

/**
 * Miniatura di pagina in sola lettura. Inoltra ref e props residue sulla radice
 * perché AntD Dropdown clona il figlio per attaccargli ref e gestori: senza
 * l'inoltro il menù contestuale non si aprirebbe.
 */
export const PageThumb = React.forwardRef(function PageThumb(
	{index, isActive, zoneCount, thumbSrc, onSelect, head = null, className = "", ...rest},
	ref
)
{
	// `className` va estratta dalle props residue e fusa a mano: Dropdown clona il figlio
	// aggiungendo la propria classe, e lo spread dopo l'attributo cancellerebbe quella
	// calcolata qui, lasciando la miniatura senza stile.
	return (
		<div ref={ref} {...rest} className={`page-thumb ${isActive ? "active" : ""} ${className}`.trim()}>
			{head}
			<div className="page-thumb-body" onClick={() => onSelect?.(index)}>
				<div className="page-thumb-image">
					{thumbSrc
						? <img src={thumbSrc} alt={`Pagina ${index + 1}`} loading="lazy"/>
						: <div className="page-thumb-placeholder">N/D</div>}
				</div>
				<Text type="secondary" style={{fontSize: 12}}>Pag. {index + 1}</Text>
				<Text type="secondary" className="page-thumb-meta">Gabbie: {zoneCount}</Text>
			</div>
		</div>
	);
});

/**
 * Miniatura trascinabile con maniglia e menù azioni. È un componente separato da
 * PageThumb, e non lo stesso con un interruttore, perché `useSortable` non può
 * essere invocato condizionalmente: la versione in sola lettura non deve proprio
 * chiamarlo.
 */
export function SortablePageThumb({page, index, isActive, zoneCount, thumbSrc, onSelect, onMenuAction})
{
	const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({id: page.name || String(index)});

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		opacity: isDragging ? 0.4 : 1
	};

	const menu = {items: PAGE_MENU_ITEMS, onClick: ({key}) => onMenuAction(key, index)};

	const head = (
		<div className="page-thumb-head">
			<div className="page-thumb-drag-handle" {...attributes} {...listeners}>
				<MenuOutlined style={{color: "#bfbfbf", fontSize: 12}}/>
			</div>
			<Dropdown menu={menu} trigger={["click"]}>
				<button
					type="button"
					className="page-thumb-actions"
					onClick={(event) => event.stopPropagation()}
				>
					<MoreOutlined style={{fontSize: 14}}/>
				</button>
			</Dropdown>
		</div>
	);

	return (
		<div ref={setNodeRef} style={style}>
			<Dropdown menu={menu} trigger={["contextMenu"]}>
				<PageThumb
					index={index}
					isActive={isActive}
					zoneCount={zoneCount}
					thumbSrc={thumbSrc}
					onSelect={onSelect}
					head={head}
				/>
			</Dropdown>
		</div>
	);
}
